import React from 'react';
import StripeProvider from '../context/StripeProvider';

const withStripeProvider = (Component) => (props) => (
  <StripeProvider>
    <Component {...props} />
  </StripeProvider>
);

export default withStripeProvider;